export const quoteStatus = {
  rejected: -1,
  clientChoseExpert: 0,
  expertAcceptClient: 1,
  clientAcceptAppointment: 2,
  appointmentAchieved: 3,
  signed: 4,
  paied: 5,
  finished: 6,
  investigation: 7,
};
